export enum Products {
  Standard = 1,
  Pro = 2,
  Agency = 3,
  Premium = 201,
  Business = 202,
  AgencyPremium = 203,
  PremiumForAgency = 211,
  Wordgenie = 800,
  AudioImport = 300,
  TextToSpeech = 700,
}

const labels: Record<number, string> = {
  [Products.Standard]: 'Standard',
  [Products.Pro]: 'Pro',
  [Products.Agency]: 'Agency',
  [Products.Premium]: 'Premium',
  [Products.Business]: 'Business',
  [Products.AgencyPremium]: 'Agency Premium',
  [Products.PremiumForAgency]: 'Premium For Agency',
}

export function getLabel(accountTypeId: number): string {
  return labels[accountTypeId] ?? 'Unknown'
}

const bookFormatRequiredPlans: Record<string, number> = {
  cover: Products.Pro,
  kindle: Products.Pro,
  printbook: Products.Premium,
  audiobook: Products.Premium,
  presentation: Products.Premium,
}

export function requiredPlanForBookFormat(format: string): number | undefined {
  return bookFormatRequiredPlans[format]
}

